<template>
  <div class="Page">
    <div class="Page-Content1" style="overflow: hidden;">
      <iframe style="width: 80%;height: 70vh;padding: 0;margin: 0;" src="./siteplan.html" frameborder="0"></iframe>
      <iframe style="width: 80%;height: 70vh;padding: 0;margin: 0;" src="./siteplan19.html" frameborder="0"></iframe>
      <iframe style="width: 80%;height: 70vh;padding: 0;margin: 0;" src="./siteplan20.html" frameborder="0"></iframe>
    </div>
    <!-- <img style="height: 100%;" src="@/assets/media/facilities.png" alt=""> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      
    }
  },
  methods:{

  },
  mounted(){

  },
}
</script>

<style lang="less">
  
  .Page-Content1{
  position: relative;
  width: 100%;
  height: auto;
  overflow: auto;
  margin: 0;
  padding: 0;
}


</style>

